import { createProvider } from '@nvision/services/data-provider';

import type { LinerTypeFilters } from '../../models';
import * as api from './api';
import { normalizeLinerTypeFilters, normalizeLinerTypes } from './normalize';

export const fetchLinerTypes = createProvider(
  (filters: Partial<LinerTypeFilters>, { signal }: { signal?: AbortController['signal'] } = {}) =>
    api.fetchLinerTypes(normalizeLinerTypeFilters(filters), { signal }),
).andThen((res) => normalizeLinerTypes(res));
